<template>
    <div class="trade-apply-rule">
        <div class="check-box bar-pad">
            <p class="top">
                <i class="fa fa-exclamation-triangle"></i>{{ title }}
            </p>
            <p v-for="(item, index) in rules" :key="index" class="line">
                {{ item.content }}
            </p>
        </div>
    </div>
</template>

<script>
export default {
    name: "TradeApplyRule",
    props: {
        title: {
            type: String,
            default: "温馨提示："
        },
        rules: {
            type: Array,
            default: ()=>{
                return [
                    { content: "T日15:00点或之前提交的申购申请，于T+1日对申购申请进行确认。" },
                    { content: "T日15:00点之后提交的申购申请，于T+2日对申购申请进行确认。" },
                    { content: "T日15:00点或之前提交的赎回申请，于T+1日对赎回申请进行确认。" },
                    { content: "T日15:00点之后提交的赎回申请，于T+2日对赎回申请进行确认。" },
                    { content: "T日、T+1日和T+2日均为交易日；" },
                    { content: "其中交易日是指证监会公布的证券基金市场交易工作日，一般周末等节假日均为非交易日。" },
                    { content: "以上未考虑周六日之外的节假日，实际如遇节假日均按周六日同理顺延。" }
                ];
            }
        }

    },
    data(){
        return {

        };
    }
};
</script>

<style scoped>
    .trade-apply-rule{
        margin-left:162px;
    }
    .bar-pad{
        color: GrayText;
        margin: 16px 16px;
        text-align: justify;
    }
    .fa-exclamation-triangle{
        color: greenyellow;
    }
    .top{
        line-height: 26px;
    }
    .line{
        line-height: 26px;
        text-indent: 2em;
        margin-right: 368px;
    }
</style>
